import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { Button } from '@microservices/wiskey-react-components'
import { Add } from '@mui/icons-material'
import { Grid } from '@mui/material'

import { PageContext } from '../../TimeLineCreateOrEdit'
import { ObjectXTotalsRow } from '../ObjectXTotalsRow'

export const ObjectXTotals = () => {
  const { t } = useTranslation()

  const { state, handlers } = useContext(PageContext)

  const { watchObjectXTotalsRows } = state

  const { handleAddObjectXTotalRow } = handlers

  return (
    <>
      {watchObjectXTotalsRows.map((item, index) => {
        return <ObjectXTotalsRow key={item.id} index={index} />
      })}
      <Grid container justifyContent={'flex-end'} pb={1} width={'100%'}>
        <Button onClick={handleAddObjectXTotalRow}>
          <Add fontSize='small' />
          {t('timeLinesCreateOrEdit.objectX.totals.addRow')}
        </Button>
      </Grid>
    </>
  )
}
